
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[slug]",
      function () {
        return require("private-next-pages/article/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[slug]"])
      });
    }
  